import { Link } from 'found'
import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

// TODO: Fix this by moving to common containers
// import ArticlePreview from '../city-page/article-preview'
// import placeholderPicture from '../../images/image-19-9-placeholder.svg'

function CategoryItem({ name, picture, description, color }) {
    return (
        <div className="row-cities-2 w-col w-col-3 w-col-medium-6">
            <div className="div-block-42 catg1" style={{borderColor: color}}>
                <img alt="" src={picture} className="city-icons"/>
                <h3 className="heading-11" style={{color: color}}>{name.toUpperCase()}</h3>
                <div className="text-block-29">{description}</div>
            </div>
        </div>
    )
}

class CategoriesSection extends Component {
    render() {
        let searchFilter = category => this.props.filter === '' || category.name.toLowerCase().includes(this.props.filter)
        let categories = this.props.categories.filter(searchFilter)

        let rows = []
        let nbPerRow = 4
        for (let i = 0; i < categories.length / nbPerRow; ++i) {
            let begin = i * nbPerRow
            let end = begin + nbPerRow
            let row = categories.slice(begin, end).map((category, index) =>
                <Link key={index} to={category.link}>
                    <CategoryItem {...category} />
                </Link>
            )
            rows.push(<div className="row-19 w-row" key={i}>{row}</div>)
        }

        if (rows.length === 0)
            rows = (<div className="row-19 w-row">{'No matching category.'}</div>)
        return (
            <div className="all-categories">
                <Helmet>
                    <meta
                        content={this.props.seo.description?this.props.seo.description:categories.reduce((a, b) => (a.length ? a + ', ' : '') + b.name, '')} 
                        name="description"
                    />
                </Helmet>
                <div className="categories-icons">{rows}</div>
            </div>
        )
    }
}

const connectRelay = CategoriesSection => class extends Component {
    render() {
        const { routeResolver } = this.props.context
        const categories = this.props.query.categories.map(c => ({
            ...c,
            link: routeResolver.category.get(c.slug),
        }))
        return  <CategoriesSection categories={categories} filter={this.props.filter} seo={this.props.seo} />
    }
}

export default createFragmentContainer(
    connectRelay(CategoriesSection),
    graphql`
        fragment categoriesSection_query on Query {
            categories {
                slug
                name
                color
                picture
            }
        }
    `
)
